/**
 * format-cards.js — auto-wires <x-format-cards> component instances.
 *
 * Finds every element with `data-format-cards-for="<select-id>"`, treats its
 * `[data-format-card]` children as the radio group, and mirrors clicks onto
 * the hidden <select> with that ID. Listens for select.change to re-sync the
 * `.active` / `aria-checked="true"` state — covers programmatic value
 * changes (e.g. autosave restore, template apply) too.
 *
 * Arrow-keys cycle within the group (standard ARIA radio pattern).
 *
 * Born 2026-06-02 with the shared <x-format-cards> Blade component
 * (resources/views/components/format-cards.blade.php). Migration targets at
 * launch: slideshow-maker, heic-converter, audio-to-video, enhance-video,
 * video-compressor, edit-video-sound, audio-compressor.
 */
(function () {
    'use strict';

    function wire(group) {
        var selectId = group.getAttribute('data-format-cards-for');
        if (!selectId) return;
        var sel = document.getElementById(selectId);
        if (!sel) return;
        var cards = Array.prototype.slice.call(group.querySelectorAll('[data-format-card]'));
        if (!cards.length) return;

        function sync() {
            var val = sel.value;
            cards.forEach(function (c) {
                var a = c.getAttribute('data-format-card') === val;
                c.classList.toggle('active', a);
                c.setAttribute('aria-checked', a ? 'true' : 'false');
            });
        }

        cards.forEach(function (card) {
            card.addEventListener('click', function () {
                var v = card.getAttribute('data-format-card');
                if (sel.value !== v) {
                    sel.value = v;
                    sel.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
            card.addEventListener('keydown', function (e) {
                if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
                e.preventDefault();
                var i = cards.indexOf(card);
                var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
                var next = cards[(i + step + cards.length) % cards.length];
                if (next) { next.focus(); next.click(); }
            });
        });

        sel.addEventListener('change', sync);
        sync();
    }

    function init() {
        document.querySelectorAll('[data-format-cards-for]').forEach(wire);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
